import {
  MINIMUM_VIDEO_COMPARISON_SELECTIONS,
  parseReportFilterUrl,
  parseVideoSelectionUrl,
} from "@meta-video/contracts";

import { normalizeCustomerReturnTarget } from "../../shared/auth/customerReturnTarget.js";
import { parseComparisonViewSearch } from "../../shared/url/comparisonSearch.js";
import { parseWorkspaceSearch } from "../../shared/url/workspaceSearch.js";

export function canonicalCustomerWorkspaceUrl(
  input: string,
  origin: string,
): string | null {
  const target = normalizeCustomerReturnTarget(input, origin);
  if (target === null) return null;

  const url = new URL(target, origin);
  const filters = parseReportFilterUrl(url.search);
  const workspace = parseWorkspaceSearch(url.search);
  const comparison = parseVideoSelectionUrl(url.search);
  const comparisonView = parseComparisonViewSearch(url.search);
  if (
    filters.kind === "invalid"
    || workspace.kind === "invalid"
    || comparison.kind === "invalid"
    || comparisonView.kind === "invalid"
  ) {
    return null;
  }

  if (
    url.pathname === "/"
    && filters.kind !== "valid"
    && workspace.savedViewId === null
  ) {
    return null;
  }

  const hasComparison = url.searchParams.has("compare");
  if (
    hasComparison
    && (comparison.kind !== "valid" || comparison.selections.length === 0)
  ) {
    return null;
  }
  if (
    comparisonView.kind === "valid"
    && (
      comparison.kind !== "valid"
      || comparison.selections.length < MINIMUM_VIDEO_COMPARISON_SELECTIONS
      || workspace.videoView
    )
  ) {
    return null;
  }

  const identities = [
    ...(workspace.video === null ? [] : [workspace.video]),
    ...(comparison.kind === "valid" ? comparison.selections : []),
  ];
  if (identities.length > 0) {
    if (filters.kind !== "valid") return null;
    const permittedBrands = new Set(filters.state.brandIds);
    if (identities.some(({ brandId }) => !permittedBrands.has(brandId))) {
      return null;
    }
  }

  return url.href;
}
